import React from 'react';
import MarketingLayout from '../../components/MarketingLayout';
import { COMPANY } from './company';

export const LegalLayout: React.FC<{
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}> = ({ title, lastUpdated, children }) => (
  <MarketingLayout
    eyebrow="THE CLUBHOUSE SMALL PRINT"
    title={title}
    intro={`Clear rules make for a better round. Last updated ${lastUpdated}.`}
  >
    <section className="legal-document">{children}</section>
    <aside className="legal-contact">
      <h2>Need to talk to the clubhouse?</h2>
      <p>Questions, privacy requests and support enquiries are welcome.</p>
      <a href={`mailto:${COMPANY.contactEmail}`}>{COMPANY.contactEmail}</a>
    </aside>
  </MarketingLayout>
);

export const H2: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <h2 className="legal-heading">{children}</h2>
);

export const P: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="legal-paragraph">{children}</p>
);

export const UL: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ul className="legal-list">{children}</ul>
);

export const Note: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="legal-note">{children}</div>
);
